import { useBrand } from '@bnnvara/brand';
import React from 'react';

import { PopularRecommendationQuery } from '../../../api/queries/recommendation.gql';
import PageQuery from '../../PageQuery';
import RecommendationBlock from '../RecommendationBlock';

const PopularByBrandRecommendation = () => {
  const brand = useBrand();
  const customTitle = `Best bekeken op ${brand.name}`;
  return (
    <PageQuery
      query={PopularRecommendationQuery}
      variables={{
        paginator: { limit: 4 },
        brandId: brand.id,
      }}
    >
      {({ data }) => {
        const { edges } = data.popularRecommendation;

        return (
          <RecommendationBlock
            results={edges}
            title={customTitle}
            recomType="populair"
          />
        );
      }}
    </PageQuery>
  );
};

export default PopularByBrandRecommendation;
